import React from 'react';
import { A } from 'components/A';
import { NetworkIcon } from 'elements/NetworkIcon';
import { Post } from 'lib/types';
import { formatAccountName } from 'lib/helpers';
import { POST_TYPES, NETWORK_IDS } from 'lib/constants';
import { webAssetUrl } from 'lib/utils/imageUtils';
import { getPostAccountLinkAttributes } from './link';

interface Props {
  post: Post;
  size?: 'inherit' | 'medium' | 'small' | 'large';
  linkToProfile?: boolean;
  noLink?: boolean;
  iconColor?:'color' | 'monochrome' | string;
}

export const PostAccount = ({
  post,
  size = 'small',
  linkToProfile,
  noLink,
  iconColor = 'monochrome',
}: Props) => {
  const {
    account,
    channelId,
    network,
    url,
    networkOwner,
  } = post;

  const isHidden = networkOwner?.isHidden
    || post?.networkAccount?.postingAccountOwner?.user?.isHidden;

  const username = networkOwner?.username
    || post?.networkAccount?.postingAccountOwner?.user?.username;

  const name = networkOwner?.name
    || post?.networkAccount?.postingAccountOwner?.user?.name;

  const { href, target } = getPostAccountLinkAttributes(
    linkToProfile || false,
    !isHidden,
    username || '',
    network,
    account,
    channelId,
    url,
  );

  const renderContent = () => {
    const classes = size === 'large' ? 'text-xl' : '';
    return (
      <div className="flex items-center">
        {post.type === POST_TYPES.STORY ? (
          <img
            alt="Story icon"
            src={webAssetUrl(post.network === NETWORK_IDS.snapchat ? 'Snapchat-Icon.png' : 'Instagram-Icon.png')}
            style={{ width: 50, height: 50 }}
          />
        ) : (
          <NetworkIcon
            fontSize={size}
            network={network}
            iconColor={iconColor}
          />
        )}
        <div className={`pl-1 font-bold overflow-ellipsis overflow-hidden ${classes}`}>
          @
          {formatAccountName(
            account,
            network,
            name || post?.networkAccount?.displayName,
          )}
        </div>
      </div>
    );
  };

  if (noLink) return renderContent();

  return (
    <A
      href={href}
      target={target}
      className="whitespace-nowrap overflow-ellipsis overflow-hidden"
      title={formatAccountName(
        account,
        network,
        name || post?.networkAccount?.displayName,
      )}
    >
      {renderContent()}
    </A>
  );
};
